<script>
import { Page } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'

export default {
  extends: PageFormBase,
  data() {
    return {
      redirectRoute: { name: 'Pages List' },
      livePreview: true
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Input({
          label: 'Tytuł',
          modelPath: [this, 'form', 'title'],
          multilingual: true
        })
      ]
    }
  },
  computed: {
    service() {
      return Page
    },
    livePreviewUrl() {
      return this.form.slug_pl === 'home' ? '/preview/' : '/preview/slug/'
    }
  }
}
</script>
